/**
 * Judge.me レビュー投稿者名の表示変換
 *
 * Judge.me はレビューの投稿者名を店舗側から書き換えられないため
 * （管理画面の編集にもAPIにも名前の項目がない）、
 * ウィジェットが描画した名前を表示時に「姓＋さま」へ置き換える。
 *
 * 対応するウィジェット
 *   ・新レビューウィジェット（revamp / jm-* 系クラス）
 *   ・旧ウィジェット・カルーセル（jdgm-* 系クラス）
 *   ・レビュー一覧ページの Reviews Grid（jdgm-review-card-* 系クラス）
 * 新ウィジェットは氏名の頭文字をアバターにも表示するため、そちらも合わせて変換する。
 *
 * 変換の考え方（実データ72種で検証済み）
 *   ・実名（スペース区切り）    … 姓を取り出して「◯◯さま」
 *   ・ニックネーム・匿名        … そのまま
 *   ・姓のみ／名のみ            … そのまま（姓名が揃って出ていないため）
 * 判断できないものは変換しない。誤った姓を出すより原文のままの方が安全。
 */
(function () {
  'use strict';

  var SUFFIX = 'さま';
  var NAME_SELECTOR = [
    '.jm-reviewer-info__name',            // 新レビューウィジェット
    '.jdgm-rev__author',                  // 旧ウィジェット
    '.jdgm-carousel-item__reviewer-name', // 旧カルーセル
    '.jdgm-review-card__reviewer-name'    // レビュー一覧ページのグリッド
  ].join(', ');
  var AVATAR_SELECTOR = '.jm-reviewer-avatar__initial';
  var INFO_SELECTOR = '.jm-reviewer-info';
  var DONE_ATTR = 'data-jdgm-name-done';
  var READY_CLASS = 'jdgm-name-ready';
  var FULLWIDTH_SPACE = '　';

  // そのまま表示する名前（スペースを含むが実名ではないもの）
  var KEEP = ['匿名', 'Anonymous', 'co mo'];

  // 規則で正しく判定できない個別指定
  var OVERRIDE = {
    '小畑のぞ美': '小畑' + SUFFIX,     // 区切りなしのフルネーム
    'くさたけけいこ': 'くさたけ' + SUFFIX, // 区切りなしのフルネーム（ひらがな）
    '江田': '江田' + SUFFIX,          // 姓のみ。敬称を付けて自然にする
    '勝山 和子': '勝山' + SUFFIX,      // この1件のみ「姓 名」の順
    '朝倉浩之': '朝倉' + SUFFIX        // 区切りなしのフルネーム
  };

  function normalizeKey(s) {
    return s.replace(/[\s　]+/g, ' ').trim();
  }

  /** 表示名を変換する。変換不要ならそのまま返す。 */
  function convert(raw) {
    var name = (raw || '').trim();
    if (!name) return name;

    var key = normalizeKey(name);
    if (Object.prototype.hasOwnProperty.call(OVERRIDE, key)) return OVERRIDE[key];
    if (KEEP.indexOf(key) !== -1) return name;

    var parts = key.split(' ');
    if (parts.length !== 2) return name;          // 区切りなし／3語以上は触らない

    var first = parts[0];
    var second = parts[1];

    // 姓の欄にフルネームが入っている場合（例：美和子 愛澤美和子 → 愛澤）
    if (second.length > first.length && second.slice(-first.length) === first) {
      var stripped = second.slice(0, second.length - first.length).trim();
      if (stripped) return stripped + SUFFIX;
    }

    // 全角スペース区切りは1つの氏名欄に「姓　名」と入力されたもの
    if (name.indexOf(FULLWIDTH_SPACE) !== -1) return first + SUFFIX;

    // Judge.me の標準描画は「名 姓」の順
    return second + SUFFIX;
  }

  /** アバターの頭文字を、変換後の名前のものに合わせる。 */
  function syncAvatar(nameEl, converted) {
    var info = nameEl.closest ? nameEl.closest(INFO_SELECTOR) : null;
    if (!info) return;
    var avatar = info.querySelector(AVATAR_SELECTOR);
    if (avatar) {
      // 実際の文字は入れ子の span にある。最も内側の要素を書き換える。
      var target = avatar.querySelector('span') || avatar;
      var initial = converted.charAt(0);
      if (initial && target.textContent.trim() !== initial) target.textContent = initial;
    }
    // 名前とアバターをまとめて表示解禁するための目印
    info.setAttribute(DONE_ATTR, '');
  }

  function process(root) {
    var nodes = (root || document).querySelectorAll(NAME_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute(DONE_ATTR)) continue;

      var original = el.textContent;
      var converted = convert(original);

      if (converted !== original.trim()) {
        el.textContent = converted;
        // 新ウィジェットは同じ名前を title 属性にも持たせている
        if (el.hasAttribute('title')) el.setAttribute('title', converted);
      }
      syncAvatar(el, converted);
      el.setAttribute(DONE_ATTR, '');
    }
  }

  function reveal() {
    document.documentElement.classList.remove(READY_CLASS);
  }

  function init() {
    process(document);

    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () {
        pending = null;
        process(document);
      }, 50);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // 万一この処理が動かなくても名前が消えたままにならないようにする
    window.setTimeout(reveal, 5000);
  }

  // JSが動く環境でのみ、変換前の氏名が一瞬見えるのを防ぐ
  document.documentElement.classList.add(READY_CLASS);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
